/**
 * User preferences.
 *
 * A module-scope store: preferences are genuinely app-wide, so there is no
 * provider to thread through the tree. Every write persists immediately.
 */

import { createStore, snapshot } from 'solid-js';
import type { Prefs } from '../config/defaults.ts';
import { loadPrefs, savePrefs } from '../config/storage.ts';

const [prefs, setPrefs] = createStore<Prefs>(loadPrefs());

export { prefs };

/** Current preferences as a plain object — for code outside the reactive graph. */
export const prefsSnapshot = (): Prefs => snapshot(prefs) as Prefs;

export function updatePrefs(patch: Partial<Prefs>): void {
  setPrefs((draft) => {
    Object.assign(draft, patch);
  });
  savePrefs({ ...prefsSnapshot(), ...patch });
}

/** Flips a boolean preference and returns its new value. */
export function togglePref(key: 'cinematicSwap' | 'pictureDisc' | 'crackle'): boolean {
  const next = !prefsSnapshot()[key];
  updatePrefs({ [key]: next });
  return next;
}
